import { AppDispatch } from "redux/store";
import { CallLambda } from "./CallLambda";
import { setSettings } from "redux/slices/user";
import Session from "redux/classes/Session";

export function UpdateSettingsAction(session: Session, settings: { [key: string]: any }) {
    return async (dispatch: AppDispatch, getState: () => any) => {
        // Optimistically update local settings to avoid UI flicker
        const currentSettings = getState()?.user?.settings || {};
        const optimistic = { ...currentSettings, ...settings };
        dispatch(setSettings({ settings: optimistic }));

        const payload = JSON.stringify({ settings });

        let response: { status: number; data: any } = await dispatch(CallLambda(session, "settingsUpdater", payload));

        if (response.status === 200) {
            // Use server-merged settings (authoritative)
            dispatch(setSettings({ settings: response.data.settings }));
        } else {
            // Revert on failure
            dispatch(setSettings({ settings: currentSettings }));
            throw new Error(response.data?.error_message || response.data?.error || 'Failed to update settings');
        }
    };
}

